import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useState } from 'react';

import { IS_SHAIN, USE_AQCUISITION_TREE_GROUP, USE_AQCUISITION_TREE_GROUP_NAME } from '../../../constants';

import store from '../../../store/index';

import gensenStyle from './gensenRegisterStyles';
import commonStyles from '../../styles';

import UserTree from '../../common/userTreeNew';
import DraggableDialog from '../../eleCommon/draggableDialog';
import CustomSimpleDrawer from '../../eleCommon/sp/customSimpleDrawer';

import UserTypeList from './userTypeList';

export const getDisplayAcquisitionName = (data, defaultTxt = null) => {
  const isTree = USE_AQCUISITION_TREE_GROUP.includes(Number(data.acquisitionCode));
  const displayAcquisitionName = isTree
    ? [data.acquisitionUserFirstName, data.acquisitionUserLastName].filter(Boolean).join(' ')
    : data.acquisitionMemo;
  return displayAcquisitionName || defaultTxt;
};

export default function AddAcquisition(props) {
  const { onClose, local, setLocal } = props;
  const gCommon = gensenStyle();
  const common = commonStyles();
  const { responseHeader } = store.getState();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [label, setLabel] = useState('');
  const [selectUser, setSelectUser] = useState({
    userId: local.acquisitionUserId || responseHeader.userId,
    userName: local.acquisitionUserFirstName || responseHeader.userName,
  });
  const [selectAcquisitionCodes, setSelectAcquisitionCodes] = useState({
    // 獲得者種未選択時・アルバイト選択時はデフォルトで社員を選択
    acquisitionCode: local.acquisitionCode
      && USE_AQCUISITION_TREE_GROUP.includes(local.acquisitionCode)
      ? local.acquisitionCode
      : IS_SHAIN,
    userCode: local.userCode
      && USE_AQCUISITION_TREE_GROUP_NAME.includes(local.userCode)
      ? local.userCode
      : '社員',
  });

  const setValue = (e) => {
    setSelectAcquisitionCodes({
      ...selectAcquisitionCodes,
      acquisitionCode: e,
      userCode: label,
    });
    if (!USE_AQCUISITION_TREE_GROUP.includes(Number(e))) {
      setSelectUser({});
      setOpen2(true);
    }
  };
  const onClick = () => {
    setLocal({
      ...local,
      acquisitionUserId: selectUser.userId,
      acquisitionUserFirstName: selectUser.userName,
      acquisitionMemo: null,
      acquisitionCode: selectAcquisitionCodes.acquisitionCode,
      userCode: selectAcquisitionCodes.userCode,
    });
    onClose();
  };
  const setSelf = () => {
    setLocal({
      ...local,
      acquisitionUserId: responseHeader.userId,
      acquisitionUserFirstName: responseHeader.userName,
      acquisitionUserLastName: '',
      acquisitionMemo: null,
      acquisitionCode: IS_SHAIN,
      userCode: '社員',
    });
    onClose();
  };
  // テキスト
  const [txt, setTxt] = useState(getDisplayAcquisitionName(local));
  const onChange = (e) => {
    setTxt(e.target.value);
  };
  const onSaveName = () => {
    setLocal({
      ...local,
      acquisitionUserId: '',
      acquisitionMemo: txt,
      acquisitionCode: selectAcquisitionCodes.acquisitionCode,
      userCode: selectAcquisitionCodes.userCode,
    });
    setOpen2(false);
    onClose();
  };
  return (
    <Grid className={gCommon.root}>
      <Grid className={common.header}>
        <Typography className={`${common.title2} ${gCommon.title}`}>獲得者選択</Typography>
        <Close className={gCommon.closeIcon} onClick={onClose} />
      </Grid>
      <Button
        className={gCommon.button}
        onClick={setSelf}
      >
        自分
      </Button>
      <Button
        className={gCommon.button}
        onClick={() => { return setOpen(true); }}
      >
        アカウントなし{label ? `（${label}）` : null}
      </Button>
      <CustomSimpleDrawer
        open={open}
        setOpen={setOpen}
        title="区分"
        list={
          <UserTypeList
            setValue={setValue}
            label={label}
            setLabel={setLabel}
            setOpen={setOpen}
          />
        }
      />
      <DraggableDialog
        open={open2}
        onClose={() => { return setOpen2(false); }}
      >
        <Grid className={gCommon.root}>
          <Grid className={common.header}>
            <Typography className={`${common.title2} ${gCommon.title}`}>{label}</Typography>
            <Close className={gCommon.closeIcon} onClick={onClose} />
          </Grid>
          <Grid container justifyContent="space-around">
            <TextField
              value={txt}
              onChange={(e) => { return onChange(e); }}
            />
          </Grid>
          <Grid container justifyContent="center" style={{ marginTop: 32 }}>
            <Button
              className={common.buttonsPrimary}
              onClick={onSaveName}
              disabled={!txt?.length}
            >
              選択
            </Button>
          </Grid>
        </Grid>
      </DraggableDialog>
      <UserTree
        selectUser={selectUser}
        setSelectUser={setSelectUser}
        selectDivision={[]}
        setSelectDivision={() => {}}
        isSelectUserWindow
      />
      <Grid container justifyContent="center" style={{ marginTop: 32 }}>
        <Button
          className={common.buttonsPrimary}
          onClick={onClick}
        >
          選択
        </Button>
      </Grid>
    </Grid>
  );
}
